var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0833 0C19.3042 0 22.0009 2.54682 22.0009 5.76779C22.0009 10.5618 18.4803 15.2809 11.6638 19.8502C11.514 19.9251 11.3642 20 11.1395 20C10.9896 20 10.8398 19.9251 10.69 19.8502H10.6151C3.72372 15.2809 0.203125 10.5618 0.203125 5.76779C0.203125 2.54682 2.82485 0 6.12073 0C7.46904 0 8.66754 0.449438 9.71623 1.1985C10.0908 1.49813 10.1657 2.09738 9.86605 2.47191C9.56642 2.84644 8.96717 2.92135 8.59264 2.62172C7.91848 2.09738 7.0196 1.79775 6.12073 1.79775C3.87354 1.79775 2.07578 3.59551 2.07578 5.76779C2.07578 9.73783 4.99713 13.7828 11.0645 17.9775L11.1395 18.0524L11.2144 17.9775C17.2069 13.8577 20.1282 9.81273 20.2031 5.9176V5.76779C20.2031 3.59551 18.4054 1.79775 16.1582 1.79775C14.4353 1.79775 12.8623 2.84644 12.338 4.41948C12.1881 4.86891 11.6638 5.16854 11.1395 4.94382C10.69 4.79401 10.3904 4.26966 10.6151 3.74532C11.3642 1.57303 13.6114 0 16.0833 0Z",
    fill: "#85242D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/listing.8518e4dcbfc3f1eb31d0be3f36f5384a.svg";
export { ForwardRef as ReactComponent };